import { CONSENT_FORM_SUMBITED } from "./actionTypes"

import { genericPostRequest } from "../../helpers/sf_backend_helper"
import { AppConfiguration } from "config"
import { call, takeEvery } from "redux-saga/effects"

function* onFormConsentSubmit(action) {
  try {
    const URL = `${AppConfiguration.CONSENT_EVENT_BACKEND_URL}/completeSession/${action.payload?.certificate_id}`
    const payload = {
      body: JSON.stringify({
        api_token: AppConfiguration.CONSENT_API_TOKEN,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    }
    const response = yield call(
      genericPostRequest,
      URL,
      payload
    )
  } catch (error) {
    console.log("Error in onFormConsentSubmit", error)
  }
}

function* ConsentConfirmationSaga() {
  yield takeEvery(CONSENT_FORM_SUMBITED, onFormConsentSubmit)
}

export default ConsentConfirmationSaga
